import { QRCodeSVG } from "qrcode.react";
import "@cloudscape-design/global-styles/index.css";
import { GET_REDIRECT_URL } from "../../utils/constants";
import "./AppQrCode.css";

/**
 * Printable QR poster for reInvent. Encodes the single /get URL (GET_REDIRECT_URL); scanning it opens
 * the device-routed AppRedirect page, which sends the visitor to the right app store. This page exists
 * so the QR can be rendered on screen and printed — the deployed redirect lives at /get, not here.
 *
 * Dev-only: not added to the CloudFront SPA allowlist, so it is not publicly reachable — run it locally
 * to produce the printable image.
 *
 * SVG (not canvas) so the code stays crisp at any print size. Error-correction level H tolerates a
 * logo overlay or print smudging on the physical poster.
 */
export const AppQrCode = () => {
  return (
    <div className="app-qr--wrapper">
      <div className="app-qr--content">
        <h1>Get AWS Card Clash</h1>
        <p>Scan to download on your phone</p>
        <QRCodeSVG
          className="app-qr--code"
          value={GET_REDIRECT_URL}
          size={280}
          level="H"
          includeMargin
        />
        <p className="app-qr--url">{GET_REDIRECT_URL}</p>
      </div>
    </div>
  );
};
